import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'imported-flights',
  templateUrl: './imported-flights.component.html',
  styleUrls: ['./imported-flights.component.scss'],
})
export class ImportedFlightsComponent implements OnInit {
  @Input() flightData: any;
  public flights: any;
  public currentHeaderData: any = {
    prevPageLink: '/flights',
    title: 'trips.calender_flights.header',
  };
  constructor(private modalController: ModalController, private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.flights = this.flightData?.calenderData;
  }
  closeModal() {
    try {
      this.analyticsService.trackUnified('imported_flights_modal_closed', {
        flow: 'shared',
        outcome: 'success',
        legacy_event_name: 'imported_flights_modal_closed',
        component: 'imported-flights-component',
        button: 'close-modal-button',
      });
    } catch (error) {
      console.error('Analytics tracking failed:', error);
    }
    this.modalController.dismiss();
  }
}
